module.exports = __webpack_public_path__ + "img/text-static-icon.eac85081.svg";